module.exports = "/assets/data/38b3a42e9c32fdba2097467deb4f21ca-BD21.data.json";